/*
 *
 * ResetPassword constants
 *
 */
export const REDUCER_KEY = 'ResetPassword';
export const RESET_PASSWORD = 'app/ResetPassword/RESET_PASSWORD';
export const RESET_RESET_PASSWORD = 'app/ResetPassword/RESET_RESET_PASSWORD';
